/* @flow */
import React from 'react';
import Glyph from 'components/Glyph.jsx';

class LeftTabModalTitle extends React.Component {
  static propTypes = {
    glyphName: React.PropTypes.string.isRequired,
    glyphColor: React.PropTypes.string.isRequired,
    title: React.PropTypes.string.isRequired,
    titleShort: React.PropTypes.string.isRequired,
  };

  render() {
    const { glyphName, glyphColor, title, titleShort } = this.props;
    return (
      <div>
        <Glyph name={glyphName} color={glyphColor} size="medium" />
        <span className="LeftTabModal-tab-text">
          <span className="hide--mobile">{title}</span>
          <span className="hide show--mobile">{titleShort}</span>
        </span>
      </div>
    );
  }
}

export default LeftTabModalTitle;



// WEBPACK FOOTER //
// ./src/components/LeftTabModalTitle.jsx